import { createContext } from 'react';

export const ServiceWorkerContext = createContext(undefined);
